import { render, staticRenderFns } from "./RevampWeChatPoints.vue?vue&type=template&id=0d4caed9&scoped=true"
import script from "./RevampWeChatPoints.vue?vue&type=script&lang=js"
export * from "./RevampWeChatPoints.vue?vue&type=script&lang=js"
import style0 from "./RevampWeChatPoints.vue?vue&type=style&index=0&id=0d4caed9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4caed9",
  null
  
)

export default component.exports